import { createSlice } from '@reduxjs/toolkit';
import { IPayLoadRedux } from '../../app/IPayLoadRedux';
import { eReducerStatusBase } from '../../enums/eReducerStatusBase';
import { LoginOIDCRequest, ProfileRespone, LoginRespone } from '../../services/account/AccountModels';
import { ILoginVNPTRequest } from '../../model/request/auth/ILoginVNPTRequest';
import { appConst } from '../../AppConst';
export enum eAuthStatus {
    is_loging = 'is_loging',
    is_login_success = 'is_login_success',
    is_login_error = 'is_login_error',
    is_logout = 'is_logout',
    is_not_login = 'is_not_login'
}
interface authState {
    isAuthenticated: boolean;
    accessToken: string | null | undefined;
    refreshToken: string | null | undefined;
    status?: eReducerStatusBase | eAuthStatus;
    user?: ProfileRespone | undefined;
    loginVNPTRequest?: ILoginVNPTRequest | undefined;
}

const initialState: authState = {
    isAuthenticated: false,
    accessToken: null,
    refreshToken: null,
    status: eAuthStatus.is_not_login,
    user: undefined,
    loginVNPTRequest: undefined
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginSuccess: (state: authState, action: { payload: IPayLoadRedux<LoginRespone> }) => {
            state.isAuthenticated = true;
            state.accessToken = action.payload.payload?.token_info?.access_token ?? null;
            state.refreshToken = action.payload.payload?.token_info?.refresh_token ?? null;
            state.user = action.payload.payload?.profile;
            state.status = eAuthStatus.is_login_success;
        },
        loginError: (state: authState, action) => {
            state.isAuthenticated = false;
            state.accessToken = null;
            state.refreshToken = null;
            state.user = undefined;
            state.status = eAuthStatus.is_login_error;
        },
        logout: (state: authState) => {
            state.isAuthenticated = false;
            state.accessToken = null;
            state.refreshToken = null;
            state.user = undefined;
            state.status = eAuthStatus.is_logout;
        },
        loginVNPTStart: (state: authState, action: { payload: ILoginVNPTRequest }) => {
            state.loginVNPTRequest = action.payload;
            state.status = eAuthStatus.is_loging;
        },
        loginVNPTSuccess: (state: authState, action: { payload: IPayLoadRedux<LoginRespone> }) => {
            state.isAuthenticated = true;
            state.accessToken = action.payload.payload?.token_info?.access_token ?? null;
            state.refreshToken = action.payload.payload?.token_info?.refresh_token ?? null;
            state.user = action.payload.payload?.profile;
            state.status = eAuthStatus.is_login_success;
        },
        loginVNPTError: (state: authState) => {
            state.isAuthenticated = false;
            state.accessToken = null;
            state.refreshToken = null;
            state.user = undefined;
            state.status = eAuthStatus.is_login_error;
        },
        logoutVNPT: (state: authState) => {
            state.isAuthenticated = false;
            state.accessToken = null;
            state.refreshToken = null;
            state.user = undefined;
            state.status = eAuthStatus.is_logout;
        },
        setUserProfile: (state: authState, action: { payload: ProfileRespone | undefined }) => {
            state.user = action.payload;
        },
        resetAuthState: () => initialState
    }
});

export const {
    loginSuccess,
    loginError,
    logout,
    loginVNPTStart,
    loginVNPTSuccess,
    loginVNPTError,
    logoutVNPT,
    setUserProfile,
    resetAuthState
} = authSlice.actions;

export const authReducer = authSlice.reducer;
